import React from "react"
import PropTypes from "prop-types"
import Pills from "./Pills"
import BitMatrixTable from "./BitMatrixTable"

const GenericMatrixRenderer = ({ 
  data, 
  showExpandToggle = true, 
  defaultExpanded = false,
  maxHeight,
  onBitToggle,
  builderData,
  pageKey,
  currentHexValue
}) => {
  if (!data || Object.keys(data).length === 0) {
    return null
  }

  const items = Object.entries(data).map(([key, value]) => ({
    id: key,
    label: value.label || `${key.charAt(0).toUpperCase()}${key.slice(1)}`,
    render: () => (
      <BitMatrixTable 
        byteIndex={value.index || key} 
        rows={value.rows || []} 
        onBitToggle={onBitToggle}
        builderData={builderData}
        pageKey={pageKey}
        currentHexValue={currentHexValue}
      />
    )
  }))

  return (
    <div>
      <Pills
        items={items}
        defaultActive={items[0]?.id}
        showExpandToggle={showExpandToggle}
        defaultExpanded={defaultExpanded}
        maxHeight={maxHeight}
      />
    </div>
  )
}

GenericMatrixRenderer.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
  showExpandToggle: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onBitToggle: PropTypes.func,
  builderData: PropTypes.object,
  pageKey: PropTypes.string,
  currentHexValue: PropTypes.string,
}

export default GenericMatrixRenderer